import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Select,
  Space,
} from "antd";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";

function RideModal({
  open = false,
  onSave = () => {},
  onCancel = () => {},
  data = {},
  isUpdate = false,
  stations = [],
}) {
  const handleFinish = async (values) => {
    const res = await apiRequest({
      path: apiPaths.rides,
      method: "POST",
      data: values,
    });
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    message.success("Ride added");
    onSave(res);
  };

  return (
    <Modal
      title={isUpdate ? "Update Ride" : "Add Ride"}
      centered
      width={900}
      visible={open}
      onCancel={onCancel}
      footer={null}
    >
      <Form
        layout="vertical"
        onFinish={handleFinish}
        initialValues={
          Object.keys(data).length
            ? {
                ...data,
              }
            : {
                is_active: true,
              }
        }
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Rider"
              name="rider"
              rules={[
                {
                  required: true,
                  message: "Please input phone number",
                },
              ]}
            >
              <Input placeholder="Phone number" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Vehicle Number"
              name="vehicle_number"
              rules={[
                {
                  required: true,
                  message: "Please input Vehicle Number",
                },
              ]}
            >
              <Input placeholder="Vehicle Number" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Start Station"
              name="start_dock_station"
              rules={[
                {
                  required: true,
                  message: "Please select start dock station",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Search and Select Station Number"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "").includes(input)
                }
                options={stations.map((item) => ({
                  value: item._id,
                  label: item.name,
                }))}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="End Station"
              name="end_dock_station"
              rules={[
                {
                  required: true,
                  message: "Please select end dock station",
                },
              ]}
            >
              <Select
                showSearch
                placeholder="Search and Select Station Number"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label ?? "").includes(input)
                }
                options={stations.map((item) => ({
                  value: item._id,
                  label: item.name,
                }))}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Ride Cost"
              name={"cost"}
              rules={[
                {
                  required: true,
                  message: "Please input cost",
                },
              ]}
            >
              <InputNumber style={{ width: "100%" }} placeholder="cost" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Ride Duration (in min)"
              name={"duration"}
              rules={[
                {
                  required: true,
                  message: "Please input duration",
                },
              ]}
            >
              <InputNumber style={{ width: "100%" }} placeholder="duration" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              label="Ride Type"
              name={"type"}
              rules={[
                {
                  required: true,
                  message: "Please select type",
                },
              ]}
            >
              <Select placeholder="Ride type">
                {[
                  {
                    text: "UPI Ride",
                    value: "upi-ride",
                  },
                  {
                    text: "Cash Ride",
                    value: "cash-ride",
                  },
                ].map((item) => (
                  <Select.Option value={item.value} key={item.value}>
                    {item.text}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Ride Start Time"
              name="start_date"
              rules={[
                {
                  required: true,
                  message: "Please select start time",
                },
              ]}
            >
              <DatePicker
                showTime={true}
                style={{ width: "100%" }}
                placeholder="start date"
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Space style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button onClick={onCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              {isUpdate ? "Save" : "Add"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default RideModal;
